<div class="timeline">
  <div class="title">{{ title() }}</div>
  @for (row of rows(); track $index; let ind = $index) {
    <app-order-card-timeline-row [first]="ind===0" [number]="ind + 1" [title]="row.title" [description]="row.description" />
  }
</div>